/* Component Dependencies */
var erfpEventSummaryTemplate = require('templates/erfpEventSummary.hbs');
var AriesComponent = require('libs/aries-component');
var eventProfileDetails = require('templates/partials/eventProfileDetails.hbs');
var fileAttachment = require('templates/partials/attachments.hbs');
var eventGuestRooms = require('templates/partials/eventGuestRooms.hbs');
var eventSpace = require('templates/partials/eventSpaces.hbs');
var userContactDetails = require('templates/partials/userInformation.hbs');
var representativeInformation = require('templates/partials/representativeInfo.hbs');
var addressDetails = require('templates/partials/addressInformation.hbs');
var ResponsiveUtils = require('utils/responsiveUtils');

AriesComponent.create({
  type: 'erfpEventSummary',
  
  template: {
    'erfpEventSummary': erfpEventSummaryTemplate
  },
  subscribe: {
    'UPDATE_EVENT_SUMMARY': 'updateEventData',
    'ADDRESS_PULL_EVENT_SUMMARY':'updateContactInfo'
  },

  updateContactInfo: function(data){
    var res = data.split("|"); 
    var phoneCountryCode = "";
    var gsoLabel = "";
    var accountType = "";
    if(res[3] !=""){
      var phoneCountryCode = "+ " + res[3];
    }
    if(res[4] !=""){
      if(res[4] == "P" || res[4] == "Personal"){
        var accountType = "Personal Account";
      }
      else if(res[4] == "B" || res[4] == "Business"){
        var accountType = "Business Account";
      }
    }
    if(res[12] || res[13]){
      gsoLabel = "Account Representative/NSO";
    }
    this.$el.find('.addpull-event-sum-name').html(res[0] + " " + res[1]);
    this.$el.find('.addpull-event-sum-email').html(res[2]);
    this.$el.find('.addpull-event-sum-phone').html(phoneCountryCode);

    this.$el.find('.addpull-event-sum-acc-label').html(accountType);
    this.$el.find('.addpull-event-sum-company').html(res[5]);
    this.$el.find('.addpull-event-sum-addline1').html(res[6]);
    this.$el.find('.addpull-event-sum-addline2').html(res[7]);
    this.$el.find('.addpull-event-sum-city').html(res[8]);
    this.$el.find('.addpull-event-sum-stateProvince').html(res[9]);
    this.$el.find('.addpull-event-sum-postalCode').html(res[10]);
    this.$el.find('.addpull-event-sum-country').html(res[11]);
    this.$el.find('.gso-summary-name').html(res[12]);
    this.$el.find('.gso-summary-email').html(res[13]);
    this.$el.find('.gsoLabel').html(gsoLabel);   
  },
  events: {
    'click .js-toggle-accordion': 'toggleSummaryContainer',
    'click .js-open-overlay':'openEventSummaryOverlay',
    'click .js-close-overlay':'closeEventSummaryOverlay',
    'click .js-edit-button': 'backAndSubmit'
  },
  bindEvents: function() {
    var _self = this;
    this.initResponsiveUtils();
  },
  updateEventData : function(selector,jsonObj){
    var _self = this,
    eventProfileParent = _self.$el.find('.l-event-profile-section'),
    attachmentsParent = _self.$el.find('.l-attachment-section'),
    eventSummaryContainer = _self.$el.find('.l-summary-container'),
    eventGuestRoomParent = _self.$el.find('.l-guestroom-section'),
    eventSpacesParent = _self.$el.find('.l-event-space-section'),
    userDetailsParent = _self.$el.find('.l-user-information-section'),
    gsoSectionParent = _self.$el.find('.l-gso-section'),
    addressDetailsParent = _self.$el.find('.l-address-information-section');


    jsonObj.labels = {};
    $.extend(jsonObj.labels,eventSummaryContainer.data('labels'));

    switch(selector) {
      case 'eventProfileDetails':
      jsonObj.eventTypeLookUp = {};
      $.extend(jsonObj.eventTypeLookUp,eventSummaryContainer.data('eventtype'));
      eventProfileParent.html(eventProfileDetails(jsonObj));
      break;

      case 'attachmentDetails':
      attachmentsParent.html(fileAttachment(jsonObj));
      break;

      case 'eventDetailsGuestRooms':
      eventGuestRoomParent.html(eventGuestRooms(jsonObj));
      break;

      case 'eventDetailsSpaces':
      jsonObj.sittingConfigLabels = {};
      $.extend(jsonObj.sittingConfigLabels,eventSummaryContainer.data('sittingconfig'));
      eventSpacesParent.html(eventSpace(jsonObj));
      break;

      case 'userContactDetails':
      userDetailsParent.html(userContactDetails(jsonObj));
      break;

      case 'contactInfoGSO':
      gsoSectionParent.html(representativeInformation(jsonObj));
      break;

      case 'addressInformation':
      addressDetailsParent.html(addressDetails(jsonObj));
    }

  },
  toggleSummaryContainer: function(event) {
    event.stopPropagation();
    if($(event.target).hasClass('l-edit-button'))
      return;
    var accordionSelected = $(event.currentTarget),
    targetParent = accordionSelected.next();

    targetParent.slideToggle();
    accordionSelected.find('.js-toggle-arrow').toggleClass('t-icon-arrow-up').toggleClass('t-icon-arrow-down');

  },
  openEventSummaryOverlay: function() {
    var summaryContainer = this.$el.find('.l-summary-container');
    summaryContainer.removeClass('is-visible-l').addClass('t-overlay-style');
    this.$el.find('.js-close-overlay').addClass('l-display-block').removeClass('l-display-none');
    $('body').addClass('overlay-phone-handling');
  },

  closeEventSummaryOverlay: function(event){
    if(event){
      event.stopPropagation();
    }
    var summaryContainer = this.$el.find('.l-summary-container');
    this.$el.find('.js-close-overlay').removeClass('l-display-block').addClass('l-display-none');
    summaryContainer.removeClass('t-overlay-style').addClass('is-visible-l');
    $('body').removeClass('overlay-phone-handling');

  },
  /**
  * This function is used to initiate responsive utils
  */

  initResponsiveUtils : function() {
    this.responsiveUtils = ResponsiveUtils.create({
      resizeEventHandler: _.bind(this.resizeEventHandler, this)
    });
    this.responsiveUtils.init();
  },
   /**
  * This function is used to handle resize event.
  */
  resizeEventHandler: function() {
    var $window = $(window);
    var _self = this;
    // To prevent unexpected resize event fire on iphone/ipad
    if (_self.previousWindowWidth != $window.width()) {
      _self.previousWindowWidth = $window.width()
      if (this.responsiveUtils.isDesktop() || (this.responsiveUtils.isTablet() && !this.responsiveUtils.isPortrait())) {
        _self.closeEventSummaryOverlay();
      } 
    }
  },
  backAndSubmit : function(event){
    var _self = this, hiddenInput, form,
    editValue = event.currentTarget.value;
    hiddenInput = '<input type="hidden" name="'+editValue+'" '+' value="'+editValue+'" />';
    form  =  _self.$el.closest('form');
    form.append(hiddenInput);
    form.submit();
  }
});
